module.exports = __webpack_public_path__ + "assets/img/line2.26be99e6.png";